import React, { createContext, useState, useContext, useEffect } from "react";
import translations from "../translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getInitialLang = () => {
    const storedLang = localStorage.getItem("lang");
    if (storedLang) return storedLang;

    const browserLang = navigator.language.slice(0, 2);
    const supported = Object.keys(translations);
    return supported.includes(browserLang) ? browserLang : "en";
  };

  const [lang, setLangState] = useState(getInitialLang);

  // Guardar automáticamente en localStorage
  const setLang = (newLang) => {
    localStorage.setItem("lang", newLang);
    setLangState(newLang);
  };

  // Reemplazamos los {param} por los valores dados:
  const t = (key, params = {}) => {
    let text = translations[lang][key] || key;
  
    // Primero reemplazamos los parámetros personalizados
    Object.keys(params).forEach((param) => {
      const value = params[param];
      text = text.replace(new RegExp(`{${param}}`, "g"), value);
    });
  
    // Luego reemplazamos claves internas del archivo de traducción
    // El orden es importante: primero se aplican los parámetros externos (params), luego las claves internas del sistema.
    text = text.replace(/{(\w+)}/g, (match, p1) => {
      if (translations[lang][p1]) {
        return translations[lang][p1];
      }
      return match; // si no se encuentra, dejarlo como está
    });
  
    return text;
  };
  
  

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
